import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { HttpClient } from '@angular/common/http';
import { EchoService } from '../../services/echo.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit, OnDestroy {
  query = '';
  menu = false;
  profileOpen = false;
  user_id: string | null = localStorage.getItem('user_id');
  userName = localStorage.getItem('user_name') || '';
  userPhoto = localStorage.getItem('user_photo') || 'assets/images/avatar.png';
  userRole = 'Creator | Member';
  notifCount = 0;
  msgCount = 0;
  searchResults: any[] = [];
  liveCount = 0;
  private liveTimer: any;
  private msgChannel: any;
  private onMsgEvent = () => this.loadMsgCount();

  items = [
    // { label: 'Dashboard',   route: '/dashboard',   icon: 'fa-solid fa-house' },
    { label: 'My Cards',    route: '/cards',       icon: 'fa-regular fa-id-card' },
    { label: 'Create Card', route: '/create-card', icon: 'fa-solid fa-square-plus' },
    { label: 'Activity',    route: '/activities',  icon: 'fa-solid fa-chart-simple' },
    { label: 'Request',     route: '/requests',    icon: 'fa-solid fa-handshake' },
    { label: 'Contact',     route: '/contact',     icon: 'fa-solid fa-address-book' },
    { label: 'Messages',    route: '/messages',    icon: 'fa-solid fa-comment-dots', badge: 'msg' },
    { label: 'Live Chat',   route: '/live-chat',   icon: 'fa-solid fa-headset', live: true },
    { label: 'Profile',     route: '/profile',     icon: 'fa-solid fa-user' },
    { label: 'Logout',      route: '/logout',      icon: 'fa-solid fa-right-from-bracket' }
  ];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private apiService: ApiService,
    private router: Router,
    private http: HttpClient,
    private echo: EchoService
  ) {}

  ngOnInit() {
    this.renderer.addClass(document.body, 'has-sidebar');
    this.loadUser();
    this.loadLive();
    this.loadMsgCount();
    try {
      this.msgChannel = this.echo.connect().private('user.' + this.user_id).listen('.message.new', this.onMsgEvent);
    } catch (e) { /* timer se bhi update ho jayega */ }

    this.liveTimer = setInterval(() => { this.loadLive(); this.loadMsgCount(); }, 20000);
  }
  ngOnDestroy() { 
    this.renderer.removeClass(document.body, 'has-sidebar');
    clearInterval(this.liveTimer);
    try { this.msgChannel?.stopListening('.message.new', this.onMsgEvent); } catch (e) {}
  }

  loadLive() {
    if (!this.user_id) return;
    this.http.get<any>(`${environment.apiUrl}live/active`, { headers: this.echo.headers() }).subscribe({
      next: (r) => (this.liveCount = (r?.streams || []).length),
      error: () => (this.liveCount = 0)
    });
  }

  loadMsgCount() {
    if (!this.user_id) return;
    this.http.get<any>(`${environment.apiUrl}messages/unread-count`, { headers: this.echo.headers() }).subscribe({
      next: (r) => (this.msgCount = r?.total || 0),
      error: () => {}
    });
  }

  // Messages page chat parh le to badge foran kam ho
  @HostListener('window:msg-count-refresh')
  onMsgCountRefresh() { this.loadMsgCount(); }

  // response ke andar (kisi bhi level par) wo object dhoondta hai jisme name/photo ho
  private findUser(obj: any): any {
    if (!obj || typeof obj !== 'object') return null;
    const keys = Object.keys(obj).map(k => k.toLowerCase());
    if (keys.some(k => [ 'firstname'].includes(k))) return obj;
    for (const k of Object.keys(obj)) {
      const found = this.findUser(obj[k]);
      if (found) return found;
    }
    return null;
  }

  private pick(u: any, names: string[]): any {
    for (const n of names) {
      const key = Object.keys(u).find(k => k.toLowerCase() === n);
      if (key && u[key]) return u[key];
    }
    return null;
  }

  private findPhoto(u: any): string | null {
    // pehle known column names
    let p = this.pick(u, ['profile_picture']);
    // warna koi bhi string value jo base64 image lagti ho
    if (!p) {
      for (const k of Object.keys(u)) {
        const v = u[k];
        if (typeof v === 'string' && (v.startsWith('data:image') || (v.length > 500 && /^(\/9j\/|iVBOR)/.test(v)))) {
          p = v; break;
        }
      }
    }
    if (!p || typeof p !== 'string') return null;
    return p.startsWith('data:image') ? p : 'data:image/jpeg;base64,' + p;
  }

  getPhoto(u: any): string {
    const names = ['profile_image'];
    for (const n of names) {
      const key = Object.keys(u).find(k => k.toLowerCase() === n);
      const v = key ? u[key] : null;
      if (v && typeof v === 'string') {
        return v.startsWith('data:image') ? v : 'data:image/jpeg;base64,' + v;
      }
    }
    return 'assets/images/avatar.png';
  }

  loadUser() {
    if (!this.user_id) return;
    this.apiService.getUserById(Number(this.user_id)).subscribe(
      (res: any) => {
        console.log('userData response:', res);
        const u = this.findUser(res);
        if (!u) { console.warn('User object nahi mila, response upar dekho'); return; }

        const first = this.pick(u, ['firstname']) || '';
        const last = this.pick(u, ['lastname']) || '';
        const full = (first + ' ' + last).trim() || this.pick(u, ['name', 'username']) || '';
        if (full) this.userName = full;

        const photo = this.findPhoto(u);
        if (photo) this.userPhoto = photo;

        try {
          localStorage.setItem('user_name', this.userName);
          localStorage.setItem('user_photo', this.userPhoto);
        } catch (e) {
          console.warn('localStorage full, photo cache skip', e);
          localStorage.removeItem('user_photo');
        }
      },
      (err) => console.error('Error loading user', err)
    );
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: Event) {
    const box = this.el.nativeElement.querySelector('.profile-wrap');
    if (box && !box.contains(e.target)) this.profileOpen = false;
  }

  toggleMenu() { this.menu = !this.menu; }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  closeSearch() { this.query = ''; this.searchResults = []; }

  searchUsers() {
    if (this.query.trim() === '') { this.searchResults = []; return; }
    this.apiService.searchUser(this.user_id, this.query).subscribe(
      (response: any) => { if (response.status == 'Success') this.searchResults = response.Users; },
      (error) => console.error('Error searching for users', error)
    );
  }
}